import { render } from "./enemyClass.vue?vue&type=template&id=526ccc14&ts=true"
import script from "./enemyClass.vue?vue&type=script&lang=ts"
export * from "./enemyClass.vue?vue&type=script&lang=ts"

import "./enemyClass.vue?vue&type=style&index=0&id=526ccc14&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__